import React from 'react';
import topLogo from '@assets/images/top-logo.png';

import '~/404.scss';

const NotFound = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 header-logo">
                        <img alt="Mastering Skill" src={topLogo} />
                    </div>
                </div>
            </div>
            <div className="error-wrapper">
                <div>
                    <h1 className="error-title">404</h1>
                    <h4 className="error-description">Page not found</h4>
                    <p>The page you are looking is not available or has been removed</p>
                </div>
            </div>
        </>
    )
}

export default NotFound;